import React, { useEffect, useRef } from 'react'
import { Helmet } from 'react-helmet-async'
import '../css/FilmProductionAnalyzer.css'
import '../css/AiToolResultsPage.css'
import FilmProductionAnalyzerResults from '../components/filmAnalyzer/FilmProductionAnalyzerResults'
import ProductionToolsHeader from '../components/productionTools/ProductionToolsHeader'
import AiToolResultsHero from '../components/productionTools/AiToolResultsHero'
import AiToolResultsLoading from '../components/productionTools/AiToolResultsLoading'
import { useAiToolResultsPage } from '../hooks/useAiToolResultsPage'
import { AI_TOOL_TYPES } from '../utils/aiTool/payment'

const STREAM_MESSAGES = [
  'Reading your production inputs...',
  'Estimating budget range...',
  'Analyzing production risks...',
  'Building your intelligence report...',
  'Preparing results...',
]

const FilmProductionAnalyzerResultsPage = () => {
  const { loading, error, streamMsg, resultState, resetToTool } =
    useAiToolResultsPage(AI_TOOL_TYPES.PRODUCTION_ANALYZER, STREAM_MESSAGES)

  const heroMeta = resultState?.resultInputs?.title
    ? `Project: ${resultState.resultInputs.title}`
    : null
  const resultsRef = useRef(null)

  useEffect(() => {
    if (resultState && resultsRef.current) {
      resultsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, [resultState])

  return (
    <div className="production-tools-theme film-analyzer-page ai-tool-results-page">
      <Helmet>
        <title>Production Analyzer Results | PitchBlu</title>
        <link
          href="https://fonts.googleapis.com/css2?family=Anton&family=Bricolage+Grotesque:opsz,wght@12..96,200..800&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <ProductionToolsHeader badge="Production Intelligence" />

      <AiToolResultsHero
        toolType={AI_TOOL_TYPES.PRODUCTION_ANALYZER}
        meta={heroMeta}
        loading={loading}
      />

      {loading && (
        <AiToolResultsLoading
          label="● AI is analyzing your production"
          streamMsg={streamMsg}
        />
      )}

      {!loading && error && (
        <div className="ai-tool-results-error container">
          <div className="err-msg" style={{ display: 'block' }}>
            {error}
          </div>
          <div style={{ marginTop: 16 }}>
            <button type="button" className="reset-btn" onClick={resetToTool}>
              Back to Production Analyzer
            </button>
          </div>
        </div>
      )}

      {!loading && resultState && (
        <div className="container" ref={resultsRef}>
          <FilmProductionAnalyzerResults
            data={resultState.results}
            inputs={resultState.resultInputs}
            onReset={resetToTool}
          />

          <footer>
            <span>PitchBlu Production Intelligence Engine v6.0</span>
            <span className="gold">
              Production Intelligence Engine · No data stored · Global
            </span>
          </footer>
        </div>
      )}
    </div>
  )
}

export default FilmProductionAnalyzerResultsPage
